import React from 'react';

const whyGremaContent = {
  intro: `GREMA is one of the 100 concepts of GREMA CONCEPTS Company, a Fourth Industrial Revolution (4IR) problem solver. This specific concept deals with real estate, marketing, advertising, and property management. It is a global connection of businesses and customers aiming to make selling and buying easier for both parties. Many times, businesses struggle to find the actual customers they need, while at the same time customers also struggle to find the products and services they need from businesses and companies.`,
  solution: `With Grema,customers are able to identify the suppliers of goods and services they need from all forms of business, including companies (that only provide services). With our optimized “Location search” engine, gremaglobal.com offers customers an opportunity to find what they need within their proximity, saving them time and unnecessary transport costs.`,
  genuinity: `We also ensure that we ONLY advertise genuine businesses and companies that sell and offer quality products and services, respectively.`,
  realEstate: `Under real estate and property management, gremaglobal.com provides the most affordable services by ensuring that genuine property is accessible to buyers at the best fair prices on the market. gremaglobal.com also sells property on behalf of property owners on record time due to its global reach of customers and TRANSPARENCY in serving the customers.`,
  passion: `Our passion originates from the desire to make living a good life a hobby and finding what you need within your closest location a joyful moment.`,
  vision: `Our vision is to have an everlasting global connection of businesses and customers all over the world.`,
  values: [
    { name: "Integrity", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M528 160H48c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-144 240H192v-80c0-17.67 14.33-32 32-32h128c17.67 0 32 14.33 32 32v80zM576 80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v32c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V80z" />
      </svg>
    ), description: "We uphold honesty, transparency, and fairness in all our dealings with clients, tenants, and partners." },
    { name: "Excellence", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.2 23 46.1 46.4 33.7L288 439.6l129-68.1 25.1 145.5c4.3 25.1 32.8 34.6 46.4 33.7L494 226.1l105.7-103c19.1-18.5 8.6-50.8-17.7-54.6l-146.2-21.3L288 17.8c-9.1-17.5-24.1-17.5-33.1 0z" />
      </svg>
    ), description: "We are committed to delivering top-quality services, innovative solutions, and measurable results." },
    { name: "Customer-Centricity", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M496 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM528 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5zM352 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM352 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5zM208 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM208 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5z" />
      </svg>
    ), description: "Our clients are at the heart of everything we do; we tailor solutions to meet their unique needs." },
    { name: "Innovation", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M224 0c-44.2 0-80 35.8-80 80V128h160V80c0-44.2-35.8-80-80-80zM320 224v160c0 44.2-35.8 80-80 80h-32c-44.2 0-80-35.8-80-80V224H320zM64 160c0 44.2 35.8 80 80 80v80c-44.2 0-80 35.8-80 80s35.8 80 80 80h32c44.2 0 80-35.8 80-80V320c0-44.2-35.8-80-80-80H64zm128 64V160h64v64h-64zM448 320c0-44.2-35.8-80-80-80h-32v80h32c44.2 0 80 35.8 80 80s-35.8 80-80 80h-32v80h-32V320h-32v160c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V320z" />
      </svg>
    ), description: "We embrace technology and creativity to deliver cutting-edge advertising, real estate, and property management solutions." },
    { name: "Accountability", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M495.9 166.4l-231.8-129.5c-9.6-5.4-20.4-5.4-30 0L16.1 166.4c-8.9 5-14.1 14.2-14.1 24.6V400c0 14.1 11.4 25.5 25.5 25.5H486.5c14.1 0 25.5-11.4 25.5-25.5V191c0-10.4-5.2-19.6-14.1-24.6zM256 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z" />
      </svg>
    ), description: "We take full responsibility for our work and ensure consistent communication, reporting, and follow-up." },
    { name: "Professionalism", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M496 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM528 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5zM352 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM352 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5zM208 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM208 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5z" />
      </svg>
    ), description: "We maintain high standards of conduct, respect, and confidentiality in every transaction." },
    { name: "Collaboration", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M496 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM528 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5zM352 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM352 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5zM208 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM208 256c-18.1 18.1-41.9 29.5-67.6 30.6-26.6 2.1-51.5-6.5-70.6-25.6-28.5-28.5-36.4-74.8-19.3-112.5 17.6-38.6 57.3-64.4 100.2-64.4s82.5 25.8 100.2 64.4c17.1 37.7 9.2 84-19.3 112.5z" />
      </svg>
    ), description: "We believe in teamwork and strong partnerships to maximize opportunities for growth." },
    { name: "Sustainability", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M504 192h-40c-6.6 0-12 5.4-12 12s5.4 12 12 12h40c6.6 0 12-5.4 12-12s-5.4-12-12-12zm-352 0h-40c-6.6 0-12 5.4-12 12s5.4 12 12 12h40c6.6 0 12-5.4 12-12s-5.4-12-12-12zm-80 0h-40c-6.6 0-12 5.4-12 12s5.4 12 12 12h40c6.6 0 12-5.4 12-12s-5.4-12-12-12zm400 0h-40c-6.6 0-12 5.4-12 12s5.4 12 12 12h40c6.6 0 12-5.4 12-12s-5.4-12-12-12zM288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM64 480h448v-80H64v80zm192 0h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-17.7 0-32 14.3-32 32s14.3 32 32 32z" />
      </svg>
    ), description: "We promote practices that protect property value, community well-being, and long-term business success." },
    { name: "Timeliness", icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '24px', height: '24px', fill: '#ff9900', marginRight: '10px' }}>
        <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 480c-123.7 0-224-100.3-224-224S132.3 32 256 32s224 100.3 224 224-100.3 224-224 224z" />
      </svg>
    ), description: "We value time and are committed to prompt responses, efficient service delivery, and meeting deadlines for our clients." },
  ],
  safetyNote: `Much as GREMA will verify businesses, customers are STRONGLY advised to ensure they meet sellers and dealers in safe open places, especially where services are in different locations (for Land, Cars, and other properties dealings). It is still your responsibility to ensure you are free from fraud or harmful eventualities related to any transactions.`
};

const WhyGrema = () => {
  return (
    <>
      <style>
        {`
          .page-container {
            max-width: 1000px;
            margin: 0 auto;
            padding: 40px 20px;
            font-family: 'Inter', sans-serif;
            color: #333;
            line-height: 1.8;
            background-color: #f9fafb;
            border-radius: 16px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          }
          @media (max-width: 768px) {
            .page-container {
              padding: 20px 15px;
            }
          }
          .header {
            text-align: center;
            font-size: 3rem;
            font-weight: 700;
            color: #111827;
            margin-bottom: 20px;
            text-shadow: 1px 1px 2px rgba(0,0,0,0.05);
          }
          @media (max-width: 768px) {
            .header {
              font-size: 2.5rem;
            }
          }
          .subheader {
            font-size: 2rem;
            font-weight: 600;
            color: #4b5563;
            border-left: 5px solid #ff9900;
            padding-left: 15px;
            margin-top: 40px;
            margin-bottom: 20px;
          }
          .content-paragraph {
            font-size: 1rem;
            color: #4a5568;
            margin-bottom: 20px;
          }
          .content-paragraph strong {
            color: #000;
          }
          .core-values-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 20px;
            margin-top: 20px;
          }
          .value-card {
            background-color: #fff;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            padding: 25px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .value-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          }
          .value-title {
            display: flex;
            align-items: center;
            font-size: 1.3rem;
            color: #111827;
            margin-bottom: 10px;
          }
          .safety-note-container {
            background-color: #fffbeb;
            border-left: 5px solid #fbbf24;
            padding: 20px;
            margin-top: 40px;
            border-radius: 8px;
          }
          .safety-title {
            font-size: 1.25rem;
            font-weight: 700;
            color: #92400e;
            margin-bottom: 10px;
          }
          .safety-text {
            font-size: 1rem;
            color: #b45309;
            line-height: 1.6;
          }
          .safety-text strong {
            color: #78350f;
          }
        `}
      </style>
      <div className="page-container">
        <h1 className="header">Why GREMA</h1>
        <p className="content-paragraph">{whyGremaContent.intro}</p>
        <p className="content-paragraph">{whyGremaContent.solution}</p>
        <p className="content-paragraph"><strong>{whyGremaContent.genuinity}</strong></p>
        <p className="content-paragraph">{whyGremaContent.realEstate}</p>
        <p className="content-paragraph">{whyGremaContent.passion}</p>
        <h2 className="subheader">Our Vision</h2>
        <p className="content-paragraph">{whyGremaContent.vision}</p>
        <h2 className="subheader">Our Core Values</h2>
        <div className="core-values-grid">
          {whyGremaContent.values.map(value => (
            <div className="value-card" key={value.name}>
              <h3 className="value-title">
                {value.icon}
                {value.name}
              </h3>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
        </div>
        <div className="safety-note-container">
          <h3 className="safety-title">Customer Safety Precautionary Measures</h3>
          <p className="safety-text">
            Much as GREMA will verify businesses, customers are <strong>STRONGLY advised</strong> to ensure they meet sellers and dealers in safe open places, especially where services are in different locations (for Land, Cars, and other properties dealings). It is still your responsibility to ensure you are free from fraud or harmful eventualities related to any transactions.
          </p>
        </div>
      </div>
    </>
  );
};

export default WhyGrema;
export {};
